import * as tslib_1 from "tslib";
import { OptionsParam, ProductQueryParam, SearchMaskInputType, } from '../../globalTypes';
var UserInputValueToCoreMapper = /** @class */ (function () {
    function UserInputValueToCoreMapper() {
    }
    UserInputValueToCoreMapper.mapTravellers = function (travellersObject) {
        var _a;
        var query = (_a = {},
            _a[ProductQueryParam.TRAVELLERS_ADULTS] = parseInt(travellersObject.value.adults, 10),
            _a);
        if (travellersObject.value.ageOfChildrenLength > 0) {
            query[ProductQueryParam.TRAVELLERS_CHILDREN_AGE] = travellersObject.value.ageOfChildren;
        }
        else {
            delete query[ProductQueryParam.TRAVELLERS_CHILDREN_AGE];
        }
        return query;
    };
    UserInputValueToCoreMapper.mapDestination = function (destinationObject) {
        var query = {};
        if (destinationObject.value.group === void 0
            && destinationObject.value.reference === void 0)
            return query;
        switch (destinationObject.value.type) {
            case 'GENERATED_GROUP':
                query[ProductQueryParam.PRODUCT_GROUPS] = [destinationObject.value.group.id];
                break;
            case 'HOTEL':
                query[ProductQueryParam.HOTEL_CODES] = [destinationObject.value.reference.value];
                break;
            default:
                query[ProductQueryParam.PRODUCT_GROUPS] = [destinationObject.value.reference.value];
                break;
        }
        return query;
    };
    UserInputValueToCoreMapper.mapDepartureAirport = function (departureAirportObject) {
        var query = {};
        if (!departureAirportObject.value || departureAirportObject.value === [])
            return query;
        departureAirportObject.value.forEach(function (checkedElement) {
            var queryAirportGroups = query[ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_GROUPS] ? query[ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_GROUPS] : [];
            var queryAirportCodes = query[ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_CODES] ? query[ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_CODES] : [];
            if (checkedElement.id)
                query[ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_GROUPS] = queryAirportGroups.concat([checkedElement.id]);
            if (checkedElement.code)
                query[ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_CODES] = queryAirportCodes.concat([checkedElement.code]);
        });
        return query;
    };
    UserInputValueToCoreMapper.mapTravelPeriod = function (travelPeriod) {
        var query = {};
        if (travelPeriod.value.duration) {
            query[ProductQueryParam.TRAVEL_PERIOD_DURATION] = travelPeriod.value.duration;
        }
        if (travelPeriod.value.departureDate) {
            query[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DATE] = travelPeriod.value.departureDate;
        }
        if (travelPeriod.value.returnDate) {
            query[ProductQueryParam.TRAVEL_PERIOD_RETURN_DATE] = travelPeriod.value.returnDate;
        }
        if (travelPeriod.value.departureDays && Array.isArray(travelPeriod.value.departureDays) && travelPeriod.value.departureDays.length > 0) {
            query[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DAYS] = travelPeriod.value.departureDays;
        }
        return query;
    };
    UserInputValueToCoreMapper.mapHotelCategory = function (hotelCategory) {
        var query = {};
        if (hotelCategory.value) {
            query[ProductQueryParam.HOTEL_CATEGORY] = hotelCategory.value;
        }
        return query;
    };
    UserInputValueToCoreMapper.mapBoardCodes = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOption(inputValue.value);
    };
    UserInputValueToCoreMapper.mapRoomCodes = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapRecommendations = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOption(inputValue.value);
    };
    UserInputValueToCoreMapper.mapRating = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOption(inputValue.value);
    };
    UserInputValueToCoreMapper.mapLocation = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOption(inputValue.value);
    };
    UserInputValueToCoreMapper.mapFeatures = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapOtherCodes = function (inputValue) {
        var query = {};
        if (inputValue.value.airlineCodes && inputValue.value.airlineCodes.length > 0) {
            query[ProductQueryParam.FLIGHT_AIRLINE_CODES] = inputValue.value.airlineCodes;
        }
        if (inputValue.value.roomViewCodes && inputValue.value.roomViewCodes.length > 0) {
            query[ProductQueryParam.HOTEL_ROOM_VIEW_CODES] = inputValue.value.roomViewCodes;
        }
        if (inputValue.value.tourOperatorCodes && inputValue.value.tourOperatorCodes.length > 0) {
            query[ProductQueryParam.TOUR_OPERATOR_CODES] = inputValue.value.tourOperatorCodes;
        }
        return query;
    };
    UserInputValueToCoreMapper.mapTargetGroups = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapSports = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapAccommodationTypes = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOption(inputValue.value);
    };
    UserInputValueToCoreMapper.mapWintersports = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapWellness = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapFamily = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapRoomCharacteristics = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapDeals = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapTravelThemes = function (inputValue) {
        return UserInputValueToCoreMapper.createOptionsQueryForOptions(inputValue.value);
    };
    UserInputValueToCoreMapper.mapFlightDepartureTimeRange = function (inputValue) {
        var query = {};
        if (inputValue.value && Array.isArray(inputValue.value) && inputValue.value.length === 2) {
            query[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MIN] = inputValue.value[0];
            query[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MAX] = inputValue.value[1];
        }
        return query;
    };
    UserInputValueToCoreMapper.mapFlightReturnTimeRange = function (inputValue) {
        var query = {};
        if (inputValue.value && Array.isArray(inputValue.value) && inputValue.value.length === 2) {
            query[ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MIN] = inputValue.value[0];
            query[ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MAX] = inputValue.value[1];
        }
        return query;
    };
    UserInputValueToCoreMapper.mapFlightStopOverMax = function (inputValue) {
        var query = {};
        if (inputValue.value !== void 0 && inputValue.value !== null) {
            query[ProductQueryParam.FLIGHT_STOP_OVER_MAX] = inputValue.value;
        }
        return query;
    };
    UserInputValueToCoreMapper.mapFlightIgnoreOpenJaw = function (inputValue) {
        var options = {};
        if (inputValue.value) {
            options[OptionsParam.PHUB_FLIGHT_IGNORE_OPEN_JAW] = inputValue.value;
        }
        return options;
    };
    UserInputValueToCoreMapper.mapPriceRange = function (priceRange) {
        var query = {};
        if (priceRange.value) {
            if (priceRange.value.priceMax) {
                query[ProductQueryParam.PRICE_MAX] = priceRange.value.priceMax;
            }
            if (priceRange.value.priceMin) {
                query[ProductQueryParam.PRICE_MIN] = priceRange.value.priceMin;
            }
        }
        return query;
    };
    UserInputValueToCoreMapper.mapTransfer = function (transfer) {
        var query = {};
        if (transfer.value) {
            query[ProductQueryParam.EXTRAS] = ['TR'];
        }
        return query;
    };
    UserInputValueToCoreMapper.mapTrainToFlight = function (transfer) {
        var query = {};
        if (transfer.value) {
            query[ProductQueryParam.EXTRAS] = ['RAIL_AND_FLY'];
        }
        return query;
    };
    UserInputValueToCoreMapper.createOptionsQueryForOption = function (optionId) {
        var query = {};
        if (optionId) {
            query[ProductQueryParam.OPTIONS] = [];
            query[ProductQueryParam.OPTIONS].push(+optionId);
        }
        return query;
    };
    UserInputValueToCoreMapper.createOptionsQueryForOptions = function (optionIds) {
        var query = {};
        if (optionIds && Array.isArray(optionIds) && optionIds.length > 0) {
            query[ProductQueryParam.OPTIONS] = [];
            if (Array.isArray(optionIds) && optionIds.length > 0) {
                optionIds.forEach(function (optionId) {
                    query[ProductQueryParam.OPTIONS].push(+optionId);
                });
            }
            else if (!Array.isArray(optionIds)) {
                query[ProductQueryParam.OPTIONS].push(+optionIds);
            }
        }
        else if (optionIds && !Array.isArray(optionIds)) {
            return this.createOptionsQueryForOption(optionIds);
        }
        return query;
    };
    UserInputValueToCoreMapper.mapQuery = function (inputValueParam, searchMaskInputGroup, searchMaskInputType) {
        var query = {};
        if (inputValueParam === null) {
            return query;
        }
        if (inputValueParam
            && inputValueParam.value !== void 0 && inputValueParam.value !== null) {
            var mappingFunction = UserInputValueToCoreMapper.userInputQueryMapperFunctionMap.get(searchMaskInputType);
            if (mappingFunction) {
                query = tslib_1.__assign({}, query, mappingFunction(inputValueParam));
            }
        }
        return query;
    };
    UserInputValueToCoreMapper.mapOptions = function (inputValueParam, searchMaskInputGroup, searchMaskInputType) {
        var options = {};
        if (inputValueParam === null) {
            return options;
        }
        if (inputValueParam
            && inputValueParam.value) {
            var mappingFunction = UserInputValueToCoreMapper.userInputOptionsMapperFunctionMap.get(searchMaskInputType);
            if (mappingFunction) {
                options = tslib_1.__assign({}, options, mappingFunction(inputValueParam));
            }
        }
        return options;
    };
    UserInputValueToCoreMapper.userInputQueryMapperFunctionMap = new Map([
        [SearchMaskInputType.DESTINATION, UserInputValueToCoreMapper.mapDestination],
        [SearchMaskInputType.DEPARTURE_AIRPORT, UserInputValueToCoreMapper.mapDepartureAirport],
        [SearchMaskInputType.TRAVEL_PERIOD, UserInputValueToCoreMapper.mapTravelPeriod],
        [SearchMaskInputType.TRAVELLERS, UserInputValueToCoreMapper.mapTravellers],
        [SearchMaskInputType.HOTEL_CATEGORY, UserInputValueToCoreMapper.mapHotelCategory],
        [SearchMaskInputType.HOTEL_BOARD_CODES, UserInputValueToCoreMapper.mapBoardCodes],
        [SearchMaskInputType.HOTEL_ROOM_CODES, UserInputValueToCoreMapper.mapRoomCodes],
        [SearchMaskInputType.HOTEL_RECOMMENDATIONS, UserInputValueToCoreMapper.mapRecommendations],
        [SearchMaskInputType.HOTEL_RATING, UserInputValueToCoreMapper.mapRating],
        [SearchMaskInputType.LOCATION, UserInputValueToCoreMapper.mapLocation],
        [SearchMaskInputType.FEATURES, UserInputValueToCoreMapper.mapFeatures],
        [SearchMaskInputType.OTHER_CODES, UserInputValueToCoreMapper.mapOtherCodes],
        [SearchMaskInputType.TARGET_GROUPS, UserInputValueToCoreMapper.mapTargetGroups],
        [SearchMaskInputType.SPORTS, UserInputValueToCoreMapper.mapSports],
        [SearchMaskInputType.ACCOMMODATION_TYPE_CODES, UserInputValueToCoreMapper.mapAccommodationTypes],
        [SearchMaskInputType.WINTERSPORTS, UserInputValueToCoreMapper.mapWintersports],
        [SearchMaskInputType.WELLNESS, UserInputValueToCoreMapper.mapWellness],
        [SearchMaskInputType.FAMILY, UserInputValueToCoreMapper.mapFamily],
        [SearchMaskInputType.ROOMCHARACTERISTICS, UserInputValueToCoreMapper.mapRoomCharacteristics],
        [SearchMaskInputType.DEALS, UserInputValueToCoreMapper.mapDeals],
        [SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE, UserInputValueToCoreMapper.mapFlightDepartureTimeRange],
        [SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE, UserInputValueToCoreMapper.mapFlightReturnTimeRange],
        [SearchMaskInputType.FLIGHT_STOP_OVER_MAX, UserInputValueToCoreMapper.mapFlightStopOverMax],
        [SearchMaskInputType.PRICE_RANGE, UserInputValueToCoreMapper.mapPriceRange],
        [SearchMaskInputType.TRANSFER, UserInputValueToCoreMapper.mapTransfer],
        [SearchMaskInputType.TRAIN_TO_FLIGHT, UserInputValueToCoreMapper.mapTrainToFlight],
        [SearchMaskInputType.TRAVEL_THEMES, UserInputValueToCoreMapper.mapTravelThemes],
    ]);
    UserInputValueToCoreMapper.userInputOptionsMapperFunctionMap = new Map([
        [SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW, UserInputValueToCoreMapper.mapFlightIgnoreOpenJaw],
    ]);
    return UserInputValueToCoreMapper;
}());
export default UserInputValueToCoreMapper;
